import Mobile from './mobile';

export default {
  Mobile,
};
